<template>
  <div class="date-input-container">
    <label :for="'date-input-' + _uid" v-if="showLabels">
      {{ label }}
      <span v-if="isRequired" class="text-danger">*</span>
    </label>
    <div class="date-input-wrapper">
      <input
        :id="'date-input-' + _uid"
        ref="dateInput"
        type="date"
        class="form-control date-input custom-height"
        :value="value"
        :min="activeMinDate"
        :max="activeMaxDate"
        :disabled="disabled"
        @input="handleDateInput"
        @click="openCalendar"
      />
    </div>
    <template v-if="showErrors">
      <p class="text-danger mb-1" v-for="(error, idx) in errorList" :key="idx">
        <b-icon-exclamation-circle></b-icon-exclamation-circle>
        <span class="ml-1">{{ error }}</span>
      </p>
    </template>
  </div>
</template>

<script>
import validators from "../../_utils/validators";

export default {
  name: "DateInputRenderer",
  props: {
    label: String,
    properties: Object,
    useValidation: Boolean,
    validators: Array,
    disabled: { type: Boolean, default: false },
    showLabels: { type: Boolean, default: true },
    showErrors: { type: Boolean, default: true },
    minDate: String,
    maxDate: String,
    value: String,
  },
  data() {
    return {
      errorList: [],
    };
  },
  computed: {
    isRequired() {
      return (
        this.useValidation &&
        this.validators?.some((v) => v.validator === "required")
      );
    },
    activeMinDate() {
      const minValidator = this.validators?.find(
        (v) => v.validator === "minDate"
      );
      return minValidator ? minValidator.value : this.minDate;
    },
    activeMaxDate() {
      const maxValidator = this.validators?.find(
        (v) => v.validator === "maxDate"
      );
      return maxValidator ? maxValidator.value : this.maxDate;
    },
  },
  methods: {
    handleDateInput(event) {
      const inputValue = event.target.value;
      this.$emit("input", inputValue);
      if (this.useValidation) this.checkError(inputValue);
    },
    openCalendar() {
      if (this.$refs.dateInput?.showPicker) {
        this.$refs.dateInput.showPicker();
      }
    },
    checkError(date, showError = true) {
      const errors = [];

      const myDefaultValidators = [
        // { validator: "required" },
        { validator: "minDate", value: this.activeMinDate },
        { validator: "maxDate", value: this.activeMaxDate },
      ];

      for (const rule of myDefaultValidators) {
        const existingValidator = this.validators?.find(
          (v) => v.validator === rule.validator
        );
        let error = null;

        if (existingValidator) {
          error = validators[existingValidator.validator](
            date,
            existingValidator
          );
        } else if (rule.value) {
          error = validators[rule.validator](date, rule);
        }

        if (error) errors.push(error);
      }
      const requiredValidator = this.validators?.find(
        (v) => v.validator === "required"
      );
      if (requiredValidator) {
        const error = validators[requiredValidator.validator](
          date,
          requiredValidator
        );
        if (error) errors.push(error);
      }
      if (showError) this.errorList = errors;
      if (errors.length) {
        this.$emit("error", {
          key: this.key,
          errors,
        });
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.date-input-container {
  display: flex;
  flex-direction: column;
}

.date-input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #ced4da;
  border-radius: 5px;
  background: #fff;
  width: 100%;
}

.date-input {
  width: 100%;
  border: none;
  outline: none;
}

.custom-height {
  height: 1.94rem !important;
  padding: 4px 8px;
}
</style>
